import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
export const IconWarning = (props) =>
  _jsxs('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: [
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12 2a1 1 0 0 1 .862.493l10 17A1 1 0 0 1 22 21H2a1 1 0 0 1-.862-1.507l10-17A1 1 0 0 1 12 2ZM3.748 19h16.504L12 4.972 3.748 19Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
        fill: 'currentColor',
      }),
    ],
  });
IconWarning.displayName = 'IconWarning';
